<template>
  <div class="list-item">
    <div :class="{ 'main-row': true, 'main-row--left': opensOnLeft }" @click="toggleDetails">
      <template v-if="!opensOnLeft">
        <div class="main-row__col main-row__col--main" v-if="titleLink">
          <Link :to="titleLink">{{ title }}</Link>
        </div>
        <slot name="row-cols"></slot>
      </template>
      <div class="main-row__col main-row__col--actions">
        <template v-if="hasDetails">
          <span class="material-icons" :data-testid="expandIcon">{{ expandIcon }}</span>
        </template>
        <template v-if="actionToLink">
          <Link :to="titleLink">
            <span class="material-icons">{{ actionToLink }}</span>
          </Link>
        </template>
        <template>
          <span
            class="material-icons action"
            v-for="action in domActions"
            :key="action.iconName"
            :title="action.tooltip"
            @click.prevent="action.clickEvent"
            >{{ action.iconName }}
          </span>
        </template>
      </div>
      <template v-if="opensOnLeft">
        <div class="main-row__col main-row__col--main" v-if="titleLink">
          <Link :to="titleLink">{{ title }}</Link>
        </div>
        <slot name="row-cols"></slot>
      </template>
    </div>
    <div
      data-testid="listItemDetails"
      class="list-item-details"
      :class="{ 'list-item-details--visible': visible && hasDetails }"
    >
      <slot name="toggle-area"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListItem',
  data() {
    return {
      visible: this.detailsVisible,
    }
  },
  props: {
    detailsVisible: { type: Boolean, default: false },
    titleLink: String,
    actions: {
      type: Array,
      default: () => [],
    },
    hasDetails: { type: Boolean, default: true },
    title: String,
    actionToLink: String,
    opensOnLeft: { type: Boolean, default: true },
  },
  computed: {
    domActions() {
      return this.actions.map(action => {
        if (typeof action == 'string') {
          return { iconName: action, clickEvent: () => {} }
        }
        return action
      })
    },
    expandIcon() {
      return this.visible ? 'expand_less' : 'expand_more'
    },
  },
  methods: {
    toggleDetails() {
      this.visible = !this.visible
      this.$emit('toggled')
    },
  },
}
</script>

<style lang="scss" scoped>
.disabled {
  opacity: 0.5;
}

.action:hover {
  color: #000;
}

.material-icons {
  margin-left: 0.5rem;
  cursor: pointer;
}

.list-item {
  background: #fff;
  border-radius: var(--border-radius-m);
  border: 1px solid var(--border-color);
  color: #444;
  margin-bottom: 10px;
  padding: 20px;

  &.list-item--low-profile {
    color: #999;

    .material-icons {
      color: #aaa;
    }
  }
}

.main-row {
  align-items: center;
  display: flex;
  justify-content: space-between;
  column-gap: 1rem;

  &--left {
    justify-content: start;

    .material-icons {
      margin-left: 0;
      font-size: 2rem;
    }
  }

  &__col {
    display: flex;

    a {
      color: #444;

      &:hover,
      .material-icons:hover {
        color: #000;
      }
    }

    &--main {
      min-width: 0;
      flex: 1 1 auto;
      word-break: break-word;
    }
  }
}

.card--sub {
  border-color: transparent;
  .main-row {
    &--left .material-icons {
      font-size: 2rem;
      margin-right: 0.25rem;
    }
  }
}

.list-item-details {
  display: none;

  &--visible {
    display: block;
  }

  .list-item-details__wrapper {
    padding: 1rem 0;
  }
}
</style>
